import React, { FC, useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { search } from '../../apis/search-catalog';
import styles from './service-indicator.module.css';

export interface ServiceIndicatorProps {
  title?: string;
  subtitle?: string;
  metrics?: {
    id: string;
    text: string;
    detail: string;
  }[];
}

export const ServiceIndicator: FC<ServiceIndicatorProps> = ({
  title = 'Conheça o nosso novo Portal',
  subtitle = 'Pergunte ao Colibri para ele te ajudar a encontrar o que você procura',
  metrics = [
    {
      id: 'service-1',
      text: '401',
      detail: 'Serviços disponíveis',
    },
    {
      id: 'service-2',
      text: '180',
      detail: 'Serviços digitais',
    },
    // {
    //   id: "service-3",
    //   text: "1.182.180",
    //   detail: "Downloads do aplicativo",
    // },
  ],
}) => {
  const [metricsData, setMetricsData] = useState(metrics);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const totalRes = await search({ from: 0, size: 1 } as any);
        const total = totalRes[0]?.resultTotal || 0;

        const onlineRes = await search({
          from: 0,
          size: 1,
          isOnline: true,
        } as any);
        const online = onlineRes[0]?.resultTotal || 0;

        setMetricsData([
          {
            id: 'services-total',
            text: total.toString(),
            detail: 'Serviços disponíveis',
          },
          { id: 'services-online', text: '252', detail: 'Serviços digitais' },
        ]);
      } catch (err) {
        console.error('Erro ao buscar métricas de serviços:', err);
      }
    };

    fetchMetrics();
  }, []);

  return (
    <div className={styles.serviceIndicator}>
      <div className={styles.serviceIndicatorContainer}>
        <Row gutter={[15, 34]} justify="center">
          <Col
            xs={24}
            md={12}
            className={styles.serviceIndicatorHeader}
            aria-labelledby="service-indicator-title"
          >
            <h2 id="service-indicator-title" className={styles.title}>
              {title}
            </h2>
            <div className={styles.subtitle}>{subtitle}</div>
          </Col>

          <Col xs={24} md={12}>
            <Row
              gutter={[15, 34]}
              justify="start"
              className={styles.serviceIndicatorRow}
            >
              {metricsData.map((metric, index) => {
                const metricId =
                  metric.id || `service-indicator-metric-${index}`;
                return (
                  <Col
                    key={metricId}
                    xs={24}
                    sm={8}
                    md={8}
                    className={styles.serviceIndicatorMetric}
                    aria-labelledby={`${metricId}-title`}
                    aria-describedby={`${metricId}-detail`}
                  >
                    <div
                      id={`${metricId}-title`}
                      className={styles.metricValue}
                    >
                      {metric.text}
                    </div>
                    <div
                      id={`${metricId}-detail`}
                      className={styles.metricLabel}
                    >
                      {metric.detail}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};
